module.exports = __webpack_public_path__ + "img/defult-avatar.efae1a07.png";